import React from 'react';
import '../static/styles/form-title.scss';

interface Props {
	title: string
}

interface State {
}

class InsFormTitle extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<div className="form-title-content">
				{this.props.title}
			</div>
		)
	}
}

export default InsFormTitle;
